import React from 'react';
import './ChatMessageUser.css';

const ChatMessageUser = ({ message }) => {
    return (
        <div className="chat-message chat-message-user">
            <div className="message-content">
                {message.content}
            </div>
        </div>
    );
};

export default ChatMessageUser;
